import styled from "styled-components";
import { borderRadius, spacing } from "@magicbi/ui-library";

export const Wrapper = styled.div`
  position: relative;
  display: inline-flex;
`;

export const Trigger = styled.button<{ $open: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${spacing[8]};
  height: ${spacing[8]};
  border: 0;
  border-radius: ${borderRadius.full};
  cursor: pointer;
  color: ${({ theme }) => theme.colors.text.secondary};
  background: ${({ theme, $open }) => ($open ? theme.colors.primary[50] : "transparent")};

  &:hover {
    background: ${({ theme }) => theme.colors.primary[50]};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary[500]};
    outline-offset: 2px;
  }
`;

export const Popover = styled.div`
  position: absolute;
  top: calc(100% + ${spacing[2]});
  right: 0;
  z-index: 1100;
`;
